/* eslint-disable import/prefer-default-export */
import clsx from 'clsx';

export const cn = (...inputs) => clsx(inputs);
